import React, { useState } from 'react'
import './Documentation.css'; // Import the CSS file
import logo from '../icici-bank.png';
import { useSelector } from 'react-redux';
import CryptoService from './CyrptoService';

export const Documentation = ({ setFlowDoc, handleDocumentUplaod, faceNotmatchStartAgain, setERefID, setDocumentImage, setSuccess }) => {

  const [id, setId] = useState()
  const handleStart = () => {
    handleDocumentUplaod()
    // setFlowDoc('DocumentUpload')
    // setFlowDoc('VedioRecorder')

    setERefID(id)

    let obj = { "request_id": id }
    console.log('Request Object:', obj);

    // // Encrypt
    const encrypted = CryptoService.encrypt(obj);
    console.log('Encrypted:', encrypted);

    // Decrypt
    // const decrypted = CryptoService.decrypt(encrypted);
    // console.log('Decrypted:', JSON.parse(decrypted));

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      "data": encrypted,
      "source_id": "1"
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow"
    };

    fetch("https://z33q3r9qqd.execute-api.ap-south-1.amazonaws.com/default/ovd_fatch_status", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        // console.log(result);
        const decrypted = CryptoService.decrypt(result.data);
        let decryptedData = JSON.parse(decrypted);
        if (decryptedData.document_base64) {
          setDocumentImage(decryptedData.document_base64);
        }
        if (decryptedData.is_document_uploaded && decryptedData.is_face_match_done && decryptedData.is_ipv_done) {
          setSuccess(true);
        }

        console.log('Decrypted:', JSON.parse(decrypted));
        if (decryptedData.is_document_uploaded) {
          setFlowDoc('VedioRecorder');
        } else {
          setFlowDoc('DocumentUpload');
        }
      })
      .catch((error) => console.error(error));
  }

  const handleSteRefId = (e) => {
    setId(e.target.value)
  }

  return (
    <div className="video-recorder-container">
      {/* Main container */}
      {/* {
        faceNotmatchStartAgain &&
        <div style={{  maxWidth: ' 450px', position: 'absolute', top: "4%", backgroundColor: 'rgba(199, 15, 15, 0.83)', borderRadius: '5px', padding: 3 }}>The face detected doesn't match the uploaded document. Please upload your original document and try again</div>
      } */}

      <div className="video-recorder-main" style={{ background: 'linear-gradient(0deg, rgba(255,219,169,1) 3%, rgba(255,236,209,1) 50%, rgba(255,240,219,1) 70%)' }}>
        <div className="video-recorder-top-bar" >
          <img src={logo} className="App-logo" alt="logo" style={{ padding: 3, width: '150px' }} />
        </div>

        <div style={{ width: "100%", position: "relative", marginTop: '4px' }}>
          <div
            style={{
              height: "1.5px",
              width: "100%",
              background: "#ccc",
              borderRadius: "2px",
              position: "relative",
            }}
          >
            <div
              style={{
                height: "1.5px",
                width: "5%",
                background: "#007bff",
                borderRadius: "2px",
                position: "absolute",
              }}
            ></div>
            <div
              style={{
                height: "8px",
                width: "8px",
                background: "#007bff",
                borderRadius: "50%",
                position: "absolute",
                left: "5%",
                top: "50%",
                transform: "translate(-50%, -50%)",
              }}
            ></div>
          </div>
        </div>

        {/* Heading & Declaration */}
        <h2 className="video-recorder-heading" style={{ color: '#464f82' }}>OVD Document Verification</h2>

        {/* Video container */}
        <div className="video-recorder-video-container"  >
          <div style={{ margin: 'auto', padding: '15px', background: '#F8F9FA', borderRadius: '6px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', marginBottom: '1rem' }}>
            <h2 style={{ fontSize: '14px', fontWeight: '600', color: 'rgb(0, 37, 124)' }}>Step 1 : Document Upload</h2>
            <ul style={{ paddingLeft: '15px', color: '#555', marginTop: '2px', marginLeft: '4px' }}>
              <li>Aadhaar Card</li>
              <li>Driving License (DL)</li>
              <li>Passport</li>
              <li>Voter ID</li>
              <li>MGNREGA Card</li>
            </ul>
            <h2 style={{ fontSize: '14px', fontWeight: '600', color: '#333', marginTop: '10px', color: 'rgb(0, 37, 124)' }}>Step 2 : Video OTP Verification</h2>
            <ul style={{ paddingLeft: '15px', color: '#555', marginTop: '2px', marginLeft: '4px' }}>
              <li>Clearly read the OTP to ensure proper voice recognition. Make sure you are in a well-lit and quiet environment.</li>
            </ul>
            <h2 style={{ fontSize: '14px', fontWeight: '600', color: '#333', marginTop: '10px', color: 'rgb(0, 37, 124)' }}>Step 3 : Face Matching</h2>
            <ul style={{ paddingLeft: '15px', color: '#555', marginTop: '2px', marginLeft: '4px' }}>
              <li>The system will match your face from the Video OTP with the photo in your uploaded document.</li>
            </ul>
          </div>
          <li>Ensure the document is clear, visible, and not cropped.</li>
          <li>Avoid glare or reflections on the document.</li>
          <input type='text' placeholder='Enter user id' style={{ width: '50%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc', marginBottom: '10px' }} onChange={handleSteRefId} />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <button
            onClick={handleStart}
            style={{
              width: '80%',
              height: '40px',
              border: '1px solid rgb(174, 1, 1)',
              backgroundColor: "rgb(174, 1, 1)",
              borderRadius: "4px",
              cursor: "pointer",
              fontSize: "16px",
              color: 'white',
              marginTop: "-1rem"
            }}
          >
            Start
          </button>
        </div>
      </div>
      <div>
      </div>

      {/* Keyframes for blink animation */}
      <style>
        {`
            @keyframes blink {
                0% { opacity: 1; }
                50% { opacity: 0.2; }
                100% { opacity: 1; }
            }
        `}
      </style>
    </div >
  )
}
